import {
  Alert,
  Button,
  Container,
  Stack,
  TextField,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  Divider,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../api/users";
import { loginUser } from "../../helpers/authHelper";
import Copyright from "../Copyright";

import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const LoginView = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [serverError, setServerError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = await login(formData);
    if (data.error) {
      setServerError(data.error);
    } else {
      loginUser(data);
      navigate("/");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #F9FAFB 0%, #EEF2FF 100%)",
        px: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 4,
            background: "rgba(255,255,255,0.9)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(0,0,0,0.05)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
          }}
        >
          {/* Brand Header */}
          <Stack spacing={1.5} alignItems="center" mb={4}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "14px",
                background: "linear-gradient(135deg,#7C3AED,#9333EA)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 26,
                color: "#fff",
              }}
            >
              💬
            </Box>
  
            <Typography variant="h4" fontWeight={700}>
              Welcome back
            </Typography>
  
            <Typography
              variant="body2"
              color="text.secondary"
              align="center"
            >
              Sign in to continue to ChatLog
            </Typography>
          </Stack>
  
          {/* Form */}
          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2.2}>
              <TextField
                fullWidth
                required
                label="Email address"
                name="email"
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
  
              <TextField
                fullWidth
                required
                label="Password"
                name="password"
                type={showPassword ? "text" : "password"}
                onChange={handleChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
  
              {serverError && (
                <Alert severity="error" sx={{ borderRadius: 2 }}>
                  {serverError}
                </Alert>
              )}
  
              <Button
                type="submit"
                size="large"
                variant="contained"
                sx={{
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: 2,
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg,#7C3AED 0%,#9333EA 100%)",
                  boxShadow: "0 8px 20px rgba(124,58,237,0.35)",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg,#6D28D9 0%,#7E22CE 100%)",
                  },
                }}
              >
                Sign in
              </Button>
            </Stack>
          </Box>
  
          <Divider sx={{ my: 4 }} />
  
          {/* Footer */}
          <Stack spacing={1.5} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              Don’t have an account?{" "}
              <Link
                to="/signup"
                style={{
                  color: "#7C3AED",
                  fontWeight: 600,
                  textDecoration: "none",
                }}
              >
                Create one
              </Link>
            </Typography>
  
            <Copyright />
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
  
  
};

export default LoginView;
